import React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { ff } from '../../../../../../theme';
import { PACKAGE_CONTENT_TYPE_OPTIONS, type PackageContentTypeOption, type TypeId } from '../../lib/packageContentTypes';

export type PackageContentTypeMenuItemsProps = {
  /** Highlights the active row’s selection (per-line “change type” menu). */
  selectedType?: TypeId;
  onSelect: (option: PackageContentTypeOption) => void;
};

/**
 * One shared list of options for “Add another type” and per-line content-type menus
 * (labels like `Instagram — Reel`).
 */
export const PackageContentTypeMenuItems: React.FC<PackageContentTypeMenuItemsProps> = ({
  selectedType,
  onSelect,
}) => (
  <>
    {PACKAGE_CONTENT_TYPE_OPTIONS.map((opt) => {
      const isActive = selectedType !== undefined && opt.type === selectedType;
      return (
        <MenuItem
          key={opt.type}
          minH="44px"
          fontSize="15px"
          fontWeight={isActive ? '600' : '400'}
          color={ff.ink}
          bg={isActive ? ff.limeSurface : undefined}
          _hover={{ bg: ff.grey }}
          onClick={() => onSelect(opt)}
        >
          {opt.dropdownLabel}
        </MenuItem>
      );
    })}
  </>
);

export const PACKAGE_CONTENT_TYPE_MENU_LIST_PROPS = {
  borderRadius: '14px',
  borderColor: ff.line,
  boxShadow: '0 8px 24px rgba(14, 14, 14, 0.08)',
  py: 1,
  fontSize: 'md' as const,
  maxH: 'min(320px, 50dvh)',
  overflowY: 'auto' as const,
  zIndex: 1500,
};
